/**
 *
 * @export
 * @class UsbStatusModel
 */
 export class UsbStatusModel {
    Running:number;
    CreateUserFinished: boolean;
    SquashFileFinished: boolean;
    FormatDeviceFinished: boolean;
    LoadImageFinished: boolean;
    CheckFileFinished: boolean;
    Error?: {code?:number; message?:string;};

    constructor(
        Running?:number,
        CreateUserFinished?: boolean,
        SquashFileFinished?: boolean,
        FormatDeviceFinished?: boolean,
        LoadImageFinished?: boolean,
        CheckFileFinished?: boolean,
        Error?: {code:number,message:string,},
    ){
        this.Running=200;
        this.CreateUserFinished=false;
        this.SquashFileFinished=false;
        this.FormatDeviceFinished=false;
        this.LoadImageFinished=false;
        this.CheckFileFinished=false;
        this.Error={};

        if (Running!==undefined){
           this.Running=Running; 
        }
        if (CreateUserFinished!==undefined){
            this.CreateUserFinished=CreateUserFinished; 
        }
        if (SquashFileFinished!==undefined){
            this.SquashFileFinished=SquashFileFinished; 
        }
        if (FormatDeviceFinished!==undefined){
            this.FormatDeviceFinished=FormatDeviceFinished; 
        }
        if (LoadImageFinished!==undefined){
            this.LoadImageFinished=LoadImageFinished; 
        }
        if (CheckFileFinished!==undefined){
            this.CheckFileFinished=CheckFileFinished; 
        }
        if (Error!==undefined){
            this.Error=Error; 
        }
    }
 }
 